import { type IssueType, type Stored } from "@overmap-ai/common"
import { selectIssueTypes } from "@overmap-ai/core"
import { ReactRenderer } from "@tiptap/react"

import { appStore } from "../../../../store"
import type { MentionListRootProps } from "../../../blocks/MentionList/Root"
import type { MentionListRef } from "../../../blocks/MentionList/typings"
import { IssueTypeMentionList } from "../../../components/MentionLists"
import type { SuggestionOptions } from "../typings"
import { updatePosition } from "../utils"

export const suggestion: SuggestionOptions<Stored<IssueType>> = {
	char: "@it",
	items: ({ query }) => {
		const issueTypes = selectIssueTypes(appStore.getState())

		return issueTypes
			.filter((issueType) => issueType.name.toLowerCase().startsWith(query.toLowerCase()))
			.slice(0, 10)
	},

	render: () => {
		let component: ReactRenderer<MentionListRef<Stored<IssueType>>, MentionListRootProps<Stored<IssueType>>>

		return {
			onStart: (props) => {
				component = new ReactRenderer(IssueTypeMentionList, {
					props,
					editor: props.editor,
					as: "div",
				})

				if (!props.clientRect) {
					return
				}

				;(component.element as HTMLElement).style.position = "fixed"
				component.element.setAttribute("data-floating-content", "")

				document.body.appendChild(component.element)

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onUpdate(props) {
				component.updateProps(props)

				if (!props.clientRect) {
					return
				}

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onKeyDown(props) {
				if (props.event.key === "Escape") {
					component.destroy()

					return true
				}

				return component.ref?.onKeyDown?.(props) ?? false
			},

			onExit() {
				component.element.remove()
				component.destroy()
			},
		}
	},
}
